import React, { useState, useEffect } from 'react'
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import logo from  '../assets/images/logo-dark.webp';

const Header = ({ settings, openLiveChat }) => {
  // State management for navbar and dropdown
  const [navbarExpanded, setNavbarExpanded] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  // Route change detection
  const location = useLocation();

  // Close menu automatically when route changes
  useEffect(() => {
    setNavbarExpanded(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  // Handle dropdown toggle - works for both mobile (click) and desktop (hover)
  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  // Desktop hover handlers (only active on desktop when navbar is collapsed)
  const handleMouseEnter = () => {
    // Only use hover on desktop (lg breakpoint and when navbar is not expanded)
    // On mobile, clicks are handled by onToggle
    if (window.innerWidth >= 992 && !navbarExpanded) {
      setDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    // Only use hover on desktop (lg breakpoint and when navbar is not expanded)
    if (window.innerWidth >= 992 && !navbarExpanded) {
      setDropdownOpen(false);
    }
  };

  // Handler to close navbar when clicking on a nav link
  const handleNavClick = () => {
    setNavbarExpanded(false);
    setDropdownOpen(false);
  };

  // Handle live chat click - close menu and open chat
  const handleLiveChatClick = (e) => {
    e.preventDefault();
    handleNavClick();
    if (openLiveChat) {
      openLiveChat();
    }
  };

  return (
    <header className={`py-2 bg-transparent`} >
      <Navbar 
        expand="lg" 
        data-bs-theme="dark"
        expanded={navbarExpanded}
        onToggle={setNavbarExpanded}
      >
        <Container>
          <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
            <img 
              src={logo} 
              alt="logo" 
              width="150" 
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" onClick={handleNavClick}>Home</Nav.Link>
              <NavDropdown 
                title="Services" 
                show={dropdownOpen} 
                onToggle={handleDropdownToggle}
                onMouseEnter={handleMouseEnter} 
                onMouseLeave={handleMouseLeave} 
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item as={Link} to="/book-publishing" onClick={handleNavClick}>Book Publishing</NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} to="/book-printing-services" onClick={handleNavClick}>Book Printing Services</NavDropdown.Item> */}
                <NavDropdown.Item as={Link} to="/book-cover-design" onClick={handleNavClick}>Book Cover Design</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ebook-ghost-writing" onClick={handleNavClick}>Book GhostWriting</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/book-editing" onClick={handleNavClick}>Book Editing</NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} to="/ebook-writing" onClick={handleNavClick}>eBook Writing</NavDropdown.Item> */}
                <NavDropdown.Item as={Link} to="/audio-book" onClick={handleNavClick}>Audio Book</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/book-marketing" onClick={handleNavClick}>Book Marketing</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/book-formatting" onClick={handleNavClick}>Book Formatting</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/childrens-book" onClick={handleNavClick}>Children's Illustrations</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/author-website" onClick={handleNavClick}>Author Website</NavDropdown.Item>
                {/* <NavDropdown.Item as={Link} to="/book-proofreading" onClick={handleNavClick}>Book Proofreading</NavDropdown.Item> */}
                {/* <NavDropdown.Item as={Link} to="/self-publishing" onClick={handleNavClick}>Self Publishing</NavDropdown.Item> */}
              </NavDropdown>
              <Nav.Link as={NavLink} to="/portfolio" onClick={handleNavClick}>Portfolio</Nav.Link>
              <Nav.Link as={NavLink} to="/case-studies" onClick={handleNavClick}>Case Studies</Nav.Link>
              <Nav.Link as={NavLink} to="/contact-us" onClick={handleNavClick}>Contact Us</Nav.Link>
              <Nav.Link as={NavLink} to="/about-us" onClick={handleNavClick}>About Us</Nav.Link>
              <Nav.Link 
                className='serv-cta-tel position-relative' 
                href={`tel:+1 (888) 208-4739`} 
                onClick={handleNavClick}
              > 
                <span><FaPhoneAlt /> +1 (888) 208-4739</span> 
              </Nav.Link>
              <Nav.Link 
                className='serv-cta-chat2 chats position-relative' 
                href="#" 
                onClick={handleLiveChatClick}
              >
                Live Chat
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header